import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import DownloadIcon from './assets/DownloadIcon';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 25,
    color: 'rgb(28,76,161)',
    border: '1px solid rgb(28,76,161)'
  }
}));

const UploadFileButton = ({ label = "工事のご案内", icon = <DownloadIcon />, onClick }) => {
  const classes = useStyles();
  return (
    <Button variant="outlined" size="medium" startIcon={icon} className={classes.root} onClick={onClick}>
      {label}
    </Button>
  )
}

export default UploadFileButton
